export default __webpack_public_path__ + "static/media/signature_2.4a528864.png";